import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  PLATFORM_ID,
  Renderer2,
  SimpleChanges
} from '@angular/core';

declare let delta: any;

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[data-dluiSelect]',
  exportAs: 'ngcSelectDirective'
})
export class NgcSelectDirective implements OnInit, AfterViewInit, OnChanges {
  @Input() devicedesktop; // render custom l&f only for desktop (default = true). i.e, [devicedesktop]='"true"'
  @Input() autorotateoption; // loop through the options list only if set true (default = false). i.e, [autorotateoption]='"false"'
  @Input() openonenter; // option list opens on Enter (default = false). i.e, [openonenter]='"false"'
  @Input() customWidth; // custopm width for select element
  @Input() customLoadingCheck;
  @Input() customClassName = 'default-theme';
  @Input() customClassNameFocus = '';
  @Input() visibleLabel = 'true';
  @Output() customChangeEvent = new EventEmitter();
  @Output() customfocusEvent = new EventEmitter();
  @Output() customfocusoutEvent = new EventEmitter();

  public optionsArray: any[] = [];
  public optionsLIArray: any[] = [];
  public currSelectedIndex;
  public suggestions: any[] = [];
  public optionIndex: number;
  public keyTracker = {
    previousKey: {},
    currentKey: {},
    counter: 0
  };
  public timeouts = [];
  previousSeachInput = '';
  private optionListULholder: any;
  private selectTextElmholder: any;
  private customSelectwraperholder: any;
  private nativeElement: Node;
  private parentElement: Node;
  private labelElement: Node;
  private nativeElementId: string;
  private customElementId: string;
  private customElementSRId: string;
  private customElementValId: string;
  private nativeElementRequiredAttr: string;
  private nativeElementDisabledAttr: string;
  private customWrapperElementNode: Node;
  private customWrapperElement;
  private selectedText: string;
  private selectMenuWidth: number;
  private selectMenuHeight: number;
  private selectMenuLeft: number;
  private selectMenuTop: number;
  private customSROnlyValue: any;
  private customSROnlyState: any;
  private isOptionVisible = false;
  private optionLength = 0;
  private keyIdleTimer = null;
  private selectedInputLetter = '';
  private prevInput = '';
  private currInput = '';
  private activeSuggestionIndex: number;
  private spaceStr: string;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private el: ElementRef,
    private ren: Renderer2
  ) {}

  ngOnChanges(changes: SimpleChanges) {}

  ngAfterViewInit(): any {
    this.reBind();
  }

  reBind(optionsData?: any, optionTextField?: any, selectedIndex?: number) {
    const parentEl = this.el.nativeElement.parentElement;
    if (parentEl) {
      if (parentEl.querySelector('.select-ui-element-wrapper')) {
        parentEl.removeChild(
          parentEl.querySelector('.select-ui-element-wrapper')
        );
      }
    }
    if (this.customLoadingCheck) {
      // setting autoRotationOption to default as false
      if (this.autorotateoption === undefined || this.autorotateoption === '') {
        this.autorotateoption = 'false';
      }
      // setting openonenter to default as false
      if (this.openonenter === undefined || this.openonenter === '') {
        this.openonenter = 'false';
      }
      // perform client side rendering and only for desktop
      if (isPlatformBrowser(this.platformId)) {
        this.nativeElement = this.el.nativeElement;
        this.parentElement = this.el.nativeElement.parentElement;
        this.labelElement = this.el.nativeElement.parentElement.children['0'];
        this.nativeElementId = this.el.nativeElement.id;
        this.customElementId = this.nativeElementId + '-label';
        this.customElementSRId = this.nativeElementId + '-desc';
        this.customElementValId = this.nativeElementId + '-val';
        this.nativeElementRequiredAttr =
          this.el.nativeElement.attributes['required'];
        this.nativeElementDisabledAttr =
          this.el.nativeElement.attributes['disabled'];
        if (optionsData && optionsData.length > 0) {
          if (selectedIndex > -1 && selectedIndex < optionsData.length) {
            this.selectedText = optionsData[selectedIndex][optionTextField];
            this.currSelectedIndex = selectedIndex;
            this.optionIndex = selectedIndex;
          } else {
            this.selectedText = optionsData[0][optionTextField];
            this.currSelectedIndex = 0;
            this.optionIndex = 0;
          }
        } else {
          this.currSelectedIndex = this.el.nativeElement.selectedIndex;
          if (this.currSelectedIndex < 0) {
            this.currSelectedIndex = 0;
          }
          if (this.el.nativeElement.options[this.currSelectedIndex]) {
            this.selectedText =
              this.el.nativeElement.options[this.currSelectedIndex].text;
          }
          this.optionIndex = this.currSelectedIndex;
        }
        this.selectMenuWidth = this.el.nativeElement.clientWidth + 2;
        this.selectMenuHeight = this.el.nativeElement.clientHeight;
        this.selectMenuLeft = this.el.nativeElement.offsetLeft;
        this.selectMenuTop = this.el.nativeElement.offsetTop;

        // hide the default select box
        this.ren.setAttribute(this.nativeElement, 'aria-hidden', 'true');
        this.ren.setAttribute(this.nativeElement, 'style', 'display:none');

        // create a wrapper for the custom select element
        const customSelectElementWrapper = this.ren.createElement('span');
        this.ren.setAttribute(
          customSelectElementWrapper,
          'class',
          'select-ui-element-wrapper ' + this.customClassName
        );

        // create a wrapper for the custom select box
        const customSelectWrapper = this.ren.createElement('span');
        this.customSelectwraperholder = customSelectWrapper;
        if (this.nativeElementDisabledAttr !== undefined) {
          this.ren.setAttribute(
            customSelectWrapper,
            'class',
            'select-ui-wrapper disabled-select-ui ' + this.customClassNameFocus
          );
          this.ren.setAttribute(customSelectWrapper, 'tabindex', '0');
          this.ren.setAttribute(customSelectWrapper, 'aria-disabled', 'true');
        } else {
          this.ren.setAttribute(
            customSelectWrapper,
            'class',
            'select-ui-wrapper ' + this.customClassNameFocus
          );
          this.ren.setAttribute(customSelectWrapper, 'tabindex', '0');
        }
        if (this.customWidth) {
          this.ren.setAttribute(
            customSelectWrapper,
            'style',
            'width:' + this.customWidth + 'px'
          );
        } else {
          this.ren.setAttribute(
            customSelectWrapper,
            'style',
            'width:' + this.selectMenuWidth + 'px'
          );
        }

        this.ren.setAttribute(
          customSelectWrapper,
          'aria-labelledby',
          this.customElementId
        );
        this.ren.setAttribute(
          customSelectWrapper,
          'aria-describedby',
          this.customElementValId
        );
        this.ren.setAttribute(
          customSelectWrapper,
          'aria-owns',
          this.customElementSRId
        );
        this.ren.setAttribute(customSelectWrapper, 'role', 'combobox');
        this.ren.setAttribute(customSelectWrapper, 'aria-expanded', 'false');
        if (this.nativeElementRequiredAttr !== undefined) {
          this.ren.setAttribute(customSelectWrapper, 'aria-required', 'true');
        }

        // create a wrapper for the screen reader only content
        const customSROnlyWrapper = this.ren.createElement('span');
        this.ren.setAttribute(
          customSROnlyWrapper,
          'class',
          'select-sr-only-wrapper sr-only'
        );

        // create a wrapper for the screen reader only content
        this.customSROnlyValue = this.ren.createElement('span');
        this.ren.setAttribute(
          this.customSROnlyValue,
          'class',
          'select-sr-only-value sr-only'
        );
        this.ren.setAttribute(this.customSROnlyValue, 'role', 'status');
        this.ren.setAttribute(this.customSROnlyValue, 'aria-live', 'assertive');

        // create a wrapper for the screen reader only content
        this.customSROnlyState = this.ren.createElement('span');
        this.ren.setAttribute(
          this.customSROnlyState,
          'class',
          'select-sr-only-state sr-only'
        );
        this.ren.setAttribute(this.customSROnlyState, 'role', 'status');
        this.ren.setAttribute(this.customSROnlyState, 'aria-live', 'assertive');

        // create custom span to hold the selected value in place of select box
        const selectTextElement = this.ren.createElement('span');
        this.selectTextElmholder = selectTextElement;

        // preset the value of custom select box
        if (this.selectedText && this.selectedText !== '') {
          selectTextElement.innerText = this.selectedText;
        }

        this.ren.setAttribute(selectTextElement, 'class', 'select-ui-text');
        this.ren.setAttribute(selectTextElement, 'aria-live', 'assertive');
        this.ren.setAttribute(selectTextElement, 'aria-hidden', 'false');
        this.ren.setAttribute(selectTextElement, 'id', this.customElementValId);

        // create select box icon element
        const selectIconElement = this.ren.createElement('span');
        this.ren.setAttribute(
          selectIconElement,
          'class',
          'select-ui-icon icon-Dropdown-caret'
        );

        // create option list for the custom select box
        const optionListUL = this.ren.createElement('ul');
        this.optionListULholder = optionListUL;
        let optionListLI;
        this.ren.setAttribute(optionListUL, 'class', 'select-ui-optionUL');
        this.ren.setAttribute(optionListUL, 'id', this.customElementSRId);
        if (this.customWidth) {
          if (this.visibleLabel === 'true') {
            this.ren.setAttribute(
              optionListUL,
              'style',
              'width:' + this.customWidth + 'px; left:0; top:18px;'
            );
          } else {
            this.ren.setAttribute(
              optionListUL,
              'style',
              'width:' + this.customWidth + 'px; left:0; top:18px;'
            );
          }
        } else {
          if (this.visibleLabel === 'true') {
            this.ren.setAttribute(
              optionListUL,
              'style',
              'width:' + this.selectMenuWidth + 'px; left:0; top:18px;'
            );
          } else {
            this.ren.setAttribute(
              optionListUL,
              'style',
              'width:' + this.selectMenuWidth + 'px; left:0; top:18px;'
            );
          }
        }

        this.ren.setAttribute(optionListUL, 'role', 'listbox');
        this.optionLength = this.el.nativeElement.options.length;
        // create option list element
        if (optionsData && optionsData.length > 0) {
          this.optionsLIArray = [];
          for (let i = 0; i < optionsData.length; i++) {
            this.optionsArray.push(optionsData[i]);
            optionListLI = this.ren.createElement('li');
            this.ren.setAttribute(
              optionListLI,
              'class',
              'select-ui-optionList'
            );
            this.ren.setAttribute(
              optionListLI,
              'id',
              'ui-list-' + this.nativeElementId + i
            );
            this.ren.setAttribute(optionListLI, 'tabindex', '-1');
            this.ren.setAttribute(optionListLI, 'data', '' + i);
            this.ren.setAttribute(optionListLI, 'role', 'option');
            optionListLI.innerText = optionsData[i][optionTextField];
            this.ren.appendChild(optionListUL, optionListLI);
            this.optionsLIArray.push(optionListLI);
          }
        } else {
          this.optionsLIArray = [];
          for (let i = 0; i < this.el.nativeElement.options.length; i++) {
            this.optionsArray.push(this.el.nativeElement.children[i]);
            optionListLI = this.ren.createElement('li');
            this.ren.setAttribute(
              optionListLI,
              'class',
              'select-ui-optionList'
            );
            this.ren.setAttribute(
              optionListLI,
              'id',
              'ui-list-' + this.nativeElementId + i
            );
            this.ren.setAttribute(optionListLI, 'tabindex', '-1');
            this.ren.setAttribute(optionListLI, 'data', '' + i);
            this.ren.setAttribute(optionListLI, 'role', 'option');
            optionListLI.innerText =
              this.el.nativeElement.children[i].innerText.trim();
            this.ren.appendChild(optionListUL, optionListLI);
            this.optionsLIArray.push(optionListLI);
          }
        }

        // create optionListWrapper
        const optionListWrapper = this.ren.createElement('span');
        this.ren.setAttribute(
          optionListWrapper,
          'class',
          'select-ui-optionList-wrapper'
        );

        // add id attribute of the label
        this.ren.setAttribute(this.labelElement, 'id', this.customElementId);

        this.ren.insertBefore(
          this.parentElement,
          customSelectElementWrapper,
          this.nativeElement
        );
        this.ren.appendChild(this.parentElement, customSelectElementWrapper);
        // this.ren.appendChild(customSelectElementWrapper, this.nativeElement);

        this.customWrapperElementNode = customSelectWrapper; // this.el.nativeElement.nextElementSibling;
        this.customWrapperElement = customSelectWrapper; // this.el.nativeElement.nextElementSibling;
        this.ren.appendChild(customSelectWrapper, selectIconElement);
        this.ren.appendChild(customSelectWrapper, selectTextElement);
        this.ren.appendChild(customSelectElementWrapper, customSelectWrapper);
        this.ren.appendChild(customSROnlyWrapper, this.customSROnlyValue);
        this.ren.appendChild(customSROnlyWrapper, this.customSROnlyState);
        this.ren.appendChild(customSelectElementWrapper, optionListWrapper);
        this.ren.appendChild(customSelectElementWrapper, customSROnlyWrapper);
        this.ren.appendChild(optionListWrapper, optionListUL);

        // hide the option list by deafult
        if (!this.isOptionVisible) {
          this.ren.addClass(optionListUL, 'hideOption');
          this.ren.setAttribute(optionListUL, 'aria-hidden', 'true');
          this.ren.setAttribute(customSelectWrapper, 'aria-expanded', 'false');
        }
        if (optionsData && optionsData.length > 0) {
          this.setActiveValue(
            this.currSelectedIndex,
            selectTextElement,
            optionListUL
          );
        }
        // if the control is disabled return
        if (this.nativeElementDisabledAttr !== undefined) {
          return;
        }

        // set focus to the custom select box , when labels are clicked
        this.ren.listen(this.labelElement, 'click', (event) => {
          this.customWrapperElement.focus();
        });

        // hide the option list if clicked outside the custom element
        this.ren.listen(document, 'click', (event) => {
          if (
            event.target !== selectTextElement &&
            event.target !== selectIconElement &&
            event.target !== customSelectWrapper
          ) {
            this.ren.addClass(optionListUL, 'hideOption');
            this.ren.setAttribute(optionListUL, 'aria-hidden', 'true');
            this.ren.setAttribute(
              customSelectWrapper,
              'aria-expanded',
              'false'
            );
            this.isOptionVisible = false;
            this.ren.setAttribute(selectTextElement, 'aria-hidden', 'false');
          }
          this.customSROnlyState.innerText = '';
          this.customSROnlyValue.innerText = '';
        });

        // hold the hover state for option list
        this.ren.listen(optionListUL, 'mouseover', (event) => {
          this.setActiveHover(event.target, optionListUL);
        });

        // hold the hover state for option list
        this.ren.listen(customSelectWrapper, 'focus', (event) => {
          // this.customSROnlyValue.innerText = this.selectedText;
          this.customfocusEvent.emit(event);
          this.customSROnlyValue.innerText = '';
        });

        // hold the hover state for option list
        this.ren.listen(customSelectWrapper, 'blur', (event) => {
          // this.customSROnlyValue.innerText = this.selectedText;
          this.customfocusoutEvent.emit(event);
        });

        // change the selected value
        this.ren.listen(optionListUL, 'click', (event) => {
          this.customWrapperElement.focus();
          this.setActiveValue(
            this.currSelectedIndex,
            selectTextElement,
            optionListUL,
            event
          );
        });

        // open the list on click of span wrapper element
        this.ren.listen(customSelectWrapper, 'click', (event) => {
          this.customWrapperElement.focus();
          this.displayOptionList(
            optionListUL,
            selectTextElement,
            customSelectWrapper
          );
        });

        // Ignore TAB, ENTER, SPACE, UP, and DOWN since they are processed by the keydown handler
        this.ren.listen(customSelectWrapper, 'keyup', (event) => {
          if (
            event.which === 13 ||
            event.keyCode === 13 ||
            event.which === 27 ||
            event.keyCode === 27 ||
            event.which === 32 ||
            event.keyCode === 32 ||
            event.which === 38 ||
            event.keyCode === 38 ||
            event.which === 40 ||
            event.keyCode === 40
          ) {
            return;
          }
        });

        // handle the wrapper keyboard event on span wrapper element
        this.ren.listen(customSelectWrapper, 'keydown', (event) => {
          this.dropdownKeyboard(event);
        });
        // handle the keyboard event on li element inside span wrapper element
        this.ren.listen(optionListUL, 'keydown', (event) => {
          this.dropdownKeyboard(event);
        });
      }
    }
  }

  public dropdownKeyboard(event: any) {
    if (
      (event.which === 32 || event.keyCode === 32) &&
      !this.isOptionVisible &&
      this.selectedInputLetter === ''
    ) {
      // SPACEBAR
      this.displayOptionList(
        this.optionListULholder,
        this.selectTextElmholder,
        this.customSelectwraperholder,
        event
      );
      event.preventDefault();
    } else if (event.altKey && (event.which === 40 || event.keycode === 40)) {
      // ALT + DOWN
      this.displayOptionList(
        this.optionListULholder,
        this.selectTextElmholder,
        this.customSelectwraperholder
      );
      event.preventDefault();
    } else if (event.altKey && (event.which === 38 || event.keycode === 38)) {
      // ALT + UP
      this.displayOptionList(
        this.optionListULholder,
        this.selectTextElmholder,
        this.customSelectwraperholder
      );
      event.preventDefault();
    } else if (event.which === 40 || event.keyCode === 40) {
      // DOWN

      const optionsLength = this.el.nativeElement.options.length;
      if (this.currSelectedIndex !== optionsLength) {
        this.currSelectedIndex++;
      }
      // this.currSelectedIndex = this.currSelectedIndex === 0 ? 1: this.currSelectedIndex;
      if (this.autorotateoption === 'true') {
        if (this.currSelectedIndex === optionsLength) {
          this.currSelectedIndex = 0;
          this.optionListULholder.scrollTop = 0;
        }
      } else {
        if (this.currSelectedIndex === optionsLength) {
          this.currSelectedIndex = optionsLength - 1;
        }
      }
      this.setActiveValue(
        this.currSelectedIndex,
        this.selectTextElmholder,
        this.optionListULholder
      );
      if (!this.isOptionVisible) {
        this.displayOptionList(
          this.optionListULholder,
          this.selectTextElmholder,
          this.customSelectwraperholder,
          event
        );
      }
      if (this.isOptionVisible) {
        this.setActiveFocus(
          this.optionListULholder.children[this.currSelectedIndex],
          this.optionListULholder
        );
        this.optionListULholder.scrollTop =
          (this.currSelectedIndex + 1) *
            (this.optionListULholder.children[this.currSelectedIndex]
              .clientHeight +
              2) -
          this.optionListULholder.clientHeight +
          (this.optionListULholder.children[this.currSelectedIndex]
            .clientHeight +
            2);
      }
      event.preventDefault();
    } else if (event.which === 38 || event.keyCode === 38) {
      // UP
      const optionsLength = this.el.nativeElement.options.length;
      if (this.currSelectedIndex !== -1) {
        this.currSelectedIndex--;
      }
      if (this.autorotateoption === 'true') {
        if (this.currSelectedIndex === -1) {
          this.currSelectedIndex = optionsLength - 1;
          this.optionListULholder.scrollTop = optionsLength * 45;
        }
        if (this.currSelectedIndex === optionsLength) {
          this.currSelectedIndex = 0;
        }
      } else {
        if (this.currSelectedIndex === -1) {
          this.currSelectedIndex = 0;
        }
      }
      this.setActiveValue(
        this.currSelectedIndex,
        this.selectTextElmholder,
        this.optionListULholder
      );
      if (!this.isOptionVisible) {
        this.displayOptionList(
          this.optionListULholder,
          this.selectTextElmholder,
          this.customSelectwraperholder,
          event
        );
      }
      if (this.isOptionVisible) {
        this.setActiveFocus(
          this.optionListULholder.children[this.currSelectedIndex],
          this.optionListULholder
        );
        this.optionListULholder.scrollTop =
          (this.currSelectedIndex + 1) *
            (this.optionListULholder.children[this.currSelectedIndex]
              .clientHeight +
              2) -
          this.optionListULholder.clientHeight +
          (this.optionListULholder.children[this.currSelectedIndex]
            .clientHeight +
            2);
      }
      event.preventDefault();
    } else if (event.altKey && (event.which === 38 || event.keycode === 38)) {
      // ALT + UP
      this.displayOptionList(
        this.optionListULholder,
        this.selectTextElmholder,
        this.customSelectwraperholder
      );
      event.preventDefault();
    } else if (event.which === 27 || event.keyCode === 27) {
      // ESC
      this.hideOptionList(
        this.optionListULholder,
        this.customSelectwraperholder
      );
      event.preventDefault();
    } else if (
      (event.shiftKey && (event.which === 9 || event.keycode === 9)) ||
      event.which === 9 ||
      event.keycode === 9
    ) {
      // TAB or SHIFT + TAB
      this.hideOptionList(
        this.optionListULholder,
        this.customSelectwraperholder
      );
      // event.preventDefault();
    } else if (event.which === 13 || event.keyCode === 13) {
      // ENTER
      if (!this.isOptionVisible) {
        if (this.openonenter === 'true') {
          this.displayOptionList(
            this.optionListULholder,
            this.selectTextElmholder,
            this.customSelectwraperholder
          );
          event.preventDefault();
        }
      } else {
        this.displayOptionList(
          this.optionListULholder,
          this.selectTextElmholder,
          this.customSelectwraperholder
        );
        event.preventDefault();
      }
    } else {
      event.preventDefault(); // prevent default in case of space pressed between words
      // auto select option on pressing of letter
      const input = event.key;
      if (input.length > 1) {
        this.currInput = '';
      } else {
        this.currInput = input;
      }

      if (
        this.currInput.toLowerCase() !== this.prevInput.toLowerCase() &&
        this.currInput.toLowerCase() !== this.previousSeachInput[0]
      ) {
        this.activeSuggestionIndex = 0;
      }

      if (this.keyIdleTimer) {
        clearTimeout(this.keyIdleTimer);
      }
      if (this.spaceStr) {
        this.selectedInputLetter += this.spaceStr;
      }

      this.selectedInputLetter += this.currInput; // concat to previously enter value
      let selectedInputLetter = this.selectedInputLetter;
      if (selectedInputLetter) {
        this.suggestions = this.getSuggestions(selectedInputLetter);
        if (this.suggestions.length === 0) {
          this.selectedInputLetter = selectedInputLetter.substring(
            selectedInputLetter.length - 1
          );
          selectedInputLetter = this.selectedInputLetter;
          this.suggestions = this.getSuggestions(selectedInputLetter);
          if (this.suggestions.length === 0) {
            this.selectedInputLetter = '';
          }
        }
      }
      this.keyIdleTimer = setTimeout(() => {
        this.keyIdleTimer = null;
        this.selectedInputLetter = '';
      }, 500); // time required for a user to hit a second letter

      if (this.suggestions.length > 0) {
        // execute only if match found
        if (this.optionIndex + 1 === this.suggestions.length) {
          this.optionIndex = 0;
        } else {
          this.optionIndex++;
        }
        this.setCurrentSelectedIndex();

        this.setActiveValue(
          this.currSelectedIndex,
          this.selectTextElmholder,
          this.optionListULholder
        );
        this.prevInput = input;
        if (this.isOptionVisible) {
          const targetElem =
            this.optionListULholder.children[this.currSelectedIndex];
          this.setActiveFocus(targetElem, this.optionListULholder);
        }
      }
      this.spaceStr = '';
    }
  }

  getSelectedSuggestionIndex(
    suggestions: Array<HTMLElement>,
    currentSelectedIndex: number
  ) {
    let selectedIndex = 0;
    suggestions.forEach((item: HTMLElement, index: number) => {
      const nodeValue = parseInt(item.attributes['data'].value, 10);
      if (nodeValue === currentSelectedIndex) {
        selectedIndex = index;
      }
    });
    return selectedIndex;
  }

  setCurrentSelectedIndex() {
    if (
      this.previousSeachInput.length > 1 &&
      this.selectedInputLetter === this.previousSeachInput[0]
    ) {
      const lastSuggestionIndex = parseInt(
        this.suggestions[this.suggestions.length - 1].attributes['data'].value,
        10
      );
      if (lastSuggestionIndex === this.currSelectedIndex) {
        this.currSelectedIndex = this.suggestions[0].attributes['data'].value;
      } else {
        const nextSuggestionindex =
          this.getSelectedSuggestionIndex(
            this.suggestions,
            this.currSelectedIndex
          ) + 1;
        this.currSelectedIndex =
          this.suggestions[nextSuggestionindex].attributes['data'].value;
      }
    } else {
      const index = this.activeSuggestionIndex++ % this.suggestions.length;
      this.currSelectedIndex = this.suggestions[index].attributes['data'].value;
      this.previousSeachInput = this.selectedInputLetter;
    }
  }

  ngOnInit(): any {
    if (!this.customLoadingCheck) {
      // setting autoRotationOption to default as false
      if (this.autorotateoption === undefined || this.autorotateoption === '') {
        this.autorotateoption = 'false';
      }
      // setting openonenter to default as false
      if (this.openonenter === undefined || this.openonenter === '') {
        this.openonenter = 'false';
      }
      // perform client side rendering and only for desktop
      if (isPlatformBrowser(this.platformId)) {
        this.nativeElement = this.el.nativeElement;
        this.parentElement = this.el.nativeElement.parentElement;
        this.labelElement = this.el.nativeElement.parentElement.children['0'];
        this.nativeElementId = this.el.nativeElement.id;
        this.customElementId = this.nativeElementId + '-label';
        this.customElementSRId = this.nativeElementId + '-desc';
        this.customElementValId = this.nativeElementId + '-val';
        this.nativeElementRequiredAttr =
          this.el.nativeElement.attributes['required'];
        this.nativeElementDisabledAttr =
          this.el.nativeElement.attributes['disabled'];
        this.selectedText =
          this.el.nativeElement.options[
            this.el.nativeElement.selectedIndex
          ].innerText;
        this.currSelectedIndex = this.el.nativeElement.selectedIndex;
        this.optionIndex = this.currSelectedIndex;
        this.selectMenuWidth = this.el.nativeElement.clientWidth + 16;
        this.selectMenuHeight = this.el.nativeElement.clientHeight;
        this.selectMenuLeft = this.el.nativeElement.offsetLeft;
        this.selectMenuTop = this.el.nativeElement.offsetTop;

        // hide the default select box
        this.ren.setAttribute(this.nativeElement, 'aria-hidden', 'true');
        this.ren.setAttribute(this.nativeElement, 'style', 'display:none');

        // create a wrapper for the custom select element
        const customSelectElementWrapper = this.ren.createElement('span');
        this.ren.setAttribute(
          customSelectElementWrapper,
          'class',
          'select-ui-element-wrapper'
        );

        // create a wrapper for the custom select box
        const customSelectWrapper = this.ren.createElement('span');
        if (this.nativeElementDisabledAttr !== undefined) {
          this.ren.setAttribute(
            customSelectWrapper,
            'class',
            'select-ui-wrapper disabled-select-ui'
          );
          this.ren.setAttribute(customSelectWrapper, 'tabindex', '0');
          this.ren.setAttribute(customSelectWrapper, 'aria-disabled', 'true');
        } else {
          this.ren.setAttribute(
            customSelectWrapper,
            'class',
            'select-ui-wrapper'
          );
          this.ren.setAttribute(customSelectWrapper, 'tabindex', '0');
        }
        if (this.customWidth) {
          this.ren.setAttribute(
            customSelectWrapper,
            'style',
            'width:' + this.customWidth + 'px;'
          );
        } else {
          this.ren.setAttribute(
            customSelectWrapper,
            'style',
            'width:' + this.selectMenuWidth + 'px;'
          );
        }

        this.ren.setAttribute(
          customSelectWrapper,
          'aria-labelledby',
          this.customElementId
        );
        this.ren.setAttribute(
          customSelectWrapper,
          'aria-describedby',
          this.customElementValId
        );
        this.ren.setAttribute(
          customSelectWrapper,
          'aria-owns',
          this.customElementSRId
        );
        this.ren.setAttribute(customSelectWrapper, 'role', 'combobox');
        this.ren.setAttribute(customSelectWrapper, 'aria-expanded', 'false');
        if (this.nativeElementRequiredAttr !== undefined) {
          this.ren.setAttribute(customSelectWrapper, 'aria-required', 'true');
        }

        // create a wrapper for the screen reader only content
        const customSROnlyWrapper = this.ren.createElement('span');
        this.ren.setAttribute(
          customSROnlyWrapper,
          'class',
          'select-sr-only-wrapper sr-only'
        );

        // create a wrapper for the screen reader only content
        this.customSROnlyValue = this.ren.createElement('span');
        this.ren.setAttribute(
          this.customSROnlyValue,
          'class',
          'select-sr-only-value sr-only'
        );
        this.ren.setAttribute(this.customSROnlyValue, 'role', 'status');
        this.ren.setAttribute(this.customSROnlyValue, 'aria-live', 'assertive');

        // create a wrapper for the screen reader only content
        this.customSROnlyState = this.ren.createElement('span');
        this.ren.setAttribute(
          this.customSROnlyState,
          'class',
          'select-sr-only-state sr-only'
        );
        this.ren.setAttribute(this.customSROnlyState, 'role', 'status');
        this.ren.setAttribute(this.customSROnlyState, 'aria-live', 'assertive');

        // create custom span to hold the selected value in place of select box
        const selectTextElement = this.ren.createElement('span');

        // preset the value of custom select box
        if (this.selectedText && this.selectedText !== '') {
          selectTextElement.innerText = this.selectedText;
        }

        this.ren.setAttribute(selectTextElement, 'class', 'select-ui-text');
        this.ren.setAttribute(selectTextElement, 'aria-hidden', 'true');
        this.ren.setAttribute(selectTextElement, 'id', this.customElementValId);

        // create select box icon element
        const selectIconElement = this.ren.createElement('span');
        this.ren.setAttribute(
          selectIconElement,
          'class',
          'select-ui-icon icon-Dropdown-caret'
        );

        // create option list for the custom select box
        const optionListUL = this.ren.createElement('ul');
        let optionListLI;
        this.ren.setAttribute(optionListUL, 'class', 'select-ui-optionUL');
        this.ren.setAttribute(optionListUL, 'id', this.customElementSRId);
        if (this.customWidth) {
          this.ren.setAttribute(
            optionListUL,
            'style',
            'width:' + this.customWidth + 'px; left:0;'
          );
        } else {
          this.ren.setAttribute(
            optionListUL,
            'style',
            'width:' + this.selectMenuWidth + 'px; left:0;'
          );
        }

        this.ren.setAttribute(optionListUL, 'role', 'listbox');

        // create option list element
        for (let i = 0; i < this.el.nativeElement.options.length; i++) {
          this.optionsArray.push(this.el.nativeElement.children[i]);
          optionListLI = this.ren.createElement('li');
          this.ren.setAttribute(optionListLI, 'class', 'select-ui-optionList');
          this.ren.setAttribute(
            optionListLI,
            'id',
            'ui-list-' + this.nativeElementId + i
          );
          this.ren.setAttribute(optionListLI, 'tabindex', '-1');
          this.ren.setAttribute(optionListLI, 'data', '' + i);
          this.ren.setAttribute(optionListLI, 'role', 'option');
          optionListLI.innerText = this.el.nativeElement.children[i].innerText;
          this.ren.appendChild(optionListUL, optionListLI);
          this.optionsLIArray.push(optionListLI);
        }

        // create optionListWrapper
        const optionListWrapper = this.ren.createElement('span');
        this.ren.setAttribute(
          optionListWrapper,
          'class',
          'select-ui-optionList-wrapper'
        );

        // add id attribute of the label
        this.ren.setAttribute(this.labelElement, 'id', this.customElementId);

        // reneder wrapper element as a child of the rendering element
        this.ren.insertBefore(
          this.parentElement,
          customSelectElementWrapper,
          this.nativeElement
        );
        this.ren.appendChild(this.parentElement, customSelectElementWrapper);
        // this.ren.appendChild(customSelectElementWrapper, this.nativeElement);

        this.customWrapperElementNode = customSelectWrapper;
        this.customWrapperElement = customSelectWrapper;
        this.ren.appendChild(customSelectWrapper, selectIconElement);
        this.ren.appendChild(customSelectWrapper, selectTextElement);
        this.ren.appendChild(customSelectElementWrapper, customSelectWrapper);
        this.ren.appendChild(customSROnlyWrapper, this.customSROnlyValue);
        this.ren.appendChild(customSROnlyWrapper, this.customSROnlyState);
        this.ren.appendChild(customSelectElementWrapper, optionListWrapper);
        this.ren.appendChild(customSelectElementWrapper, customSROnlyWrapper);
        this.ren.appendChild(optionListWrapper, optionListUL);

        // hide the option list by deafult
        if (!this.isOptionVisible) {
          this.ren.addClass(optionListUL, 'hideOption');
          this.ren.setAttribute(optionListUL, 'aria-hidden', 'true');
          this.ren.setAttribute(customSelectWrapper, 'aria-expanded', 'false');
        }

        // if the control is disabled return
        if (this.nativeElementDisabledAttr !== undefined) {
          return;
        }

        // set focus to the custom select box , when labels are clicked
        this.ren.listen(this.labelElement, 'click', (event) => {
          this.customWrapperElement.focus();
        });

        // hide the option list if clicked outside the custom element
        this.ren.listen(document, 'click', (event) => {
          if (
            event.target !== selectTextElement &&
            event.target !== selectIconElement &&
            event.target !== customSelectWrapper
          ) {
            this.ren.addClass(optionListUL, 'hideOption');
            this.ren.setAttribute(optionListUL, 'aria-hidden', 'true');
            this.ren.setAttribute(
              customSelectWrapper,
              'aria-expanded',
              'false'
            );
            this.isOptionVisible = false;
          }
          this.customSROnlyState.innerText = '';
          this.customSROnlyValue.innerText = '';
        });

        // hold the hover state for option list
        this.ren.listen(optionListUL, 'mouseover', (event) => {
          this.setActiveHover(event.target, optionListUL);
        });

        // hold the hover state for option list
        this.ren.listen(customSelectWrapper, 'focus', (event) => {
          this.customSROnlyValue.innerText = '';
        });

        // change the selected value
        this.ren.listen(optionListUL, 'click', (event) => {
          this.customWrapperElement.focus();
          this.setActiveValue(
            this.currSelectedIndex,
            selectTextElement,
            optionListUL,
            event
          );
        });

        // open the list on click of span wrapper element
        this.ren.listen(customSelectWrapper, 'click', (event) => {
          this.displayOptionList(
            optionListUL,
            selectTextElement,
            customSelectWrapper
          );
        });

        // Ignore TAB, ENTER, SPACE, UP, and DOWN since they are processed by the keydown handler
        this.ren.listen(customSelectWrapper, 'keyup', (event) => {
          if (
            event.which === 13 ||
            event.keyCode === 13 ||
            event.which === 27 ||
            event.keyCode === 27 ||
            event.which === 32 ||
            event.keyCode === 32 ||
            event.which === 38 ||
            event.keyCode === 38 ||
            event.which === 40 ||
            event.keyCode === 40
          ) {
            return;
          }
        });

        // handle the wrapper keyboard event on span wrapper element
        this.ren.listen(customSelectWrapper, 'keydown', (event) => {
          if (event.which === 32 || event.keyCode === 32) {
            // SPACEBAR
            if (!this.isOptionVisible) {
              this.displayOptionList(
                optionListUL,
                selectTextElement,
                customSelectWrapper,
                event
              );
            }
            event.preventDefault();
          } else if (
            event.altKey &&
            (event.which === 40 || event.keycode === 40)
          ) {
            // ALT + DOWN
            this.displayOptionList(
              optionListUL,
              selectTextElement,
              customSelectWrapper
            );
            event.preventDefault();
          } else if (
            event.altKey &&
            (event.which === 38 || event.keycode === 38)
          ) {
            // ALT + UP
            this.displayOptionList(
              optionListUL,
              selectTextElement,
              customSelectWrapper
            );
            event.preventDefault();
          } else if (event.which === 40 || event.keyCode === 40) {
            // DOWN
            const optionsLength = this.el.nativeElement.options.length;
            if (this.currSelectedIndex !== optionsLength) {
              this.currSelectedIndex++;
            }
            if (this.autorotateoption === 'true') {
              if (this.currSelectedIndex === optionsLength) {
                this.currSelectedIndex = 0;
                optionListUL.scrollTop = 0;
              }
            } else {
              if (this.currSelectedIndex === optionsLength) {
                this.currSelectedIndex = optionsLength - 1;
              }
            }
            this.setActiveValue(
              this.currSelectedIndex,
              selectTextElement,
              optionListUL
            );
            if (!this.isOptionVisible) {
              this.displayOptionList(
                optionListUL,
                selectTextElement,
                customSelectWrapper,
                event
              );
            }
            if (this.isOptionVisible) {
              this.setActiveFocus(
                optionListUL.children[this.currSelectedIndex],
                optionListUL
              );
              optionListUL.scrollTop =
                (this.currSelectedIndex + 1) *
                  (optionListUL.children[this.currSelectedIndex].clientHeight +
                    2) -
                optionListUL.clientHeight +
                (optionListUL.children[this.currSelectedIndex].clientHeight +
                  2);
            }
            event.preventDefault();
          } else if (event.which === 38 || event.keyCode === 38) {
            // UP
            const optionsLength = this.el.nativeElement.options.length;
            if (this.currSelectedIndex !== -1) {
              this.currSelectedIndex--;
            }
            if (this.autorotateoption === 'true') {
              if (this.currSelectedIndex === -1) {
                this.currSelectedIndex = optionsLength - 1;
                optionListUL.scrollTop = optionsLength * 45;
              }
              if (this.currSelectedIndex === optionsLength) {
                this.currSelectedIndex = 0;
              }
            } else {
              if (this.currSelectedIndex === -1) {
                this.currSelectedIndex = 0;
              }
            }
            this.setActiveValue(
              this.currSelectedIndex,
              selectTextElement,
              optionListUL
            );
            if (!this.isOptionVisible) {
              this.displayOptionList(
                optionListUL,
                selectTextElement,
                customSelectWrapper,
                event
              );
            }
            if (this.isOptionVisible) {
              this.setActiveFocus(
                optionListUL.children[this.currSelectedIndex],
                optionListUL
              );
              optionListUL.scrollTop =
                (this.currSelectedIndex + 1) *
                  (optionListUL.children[this.currSelectedIndex].clientHeight +
                    2) -
                optionListUL.clientHeight +
                (optionListUL.children[this.currSelectedIndex].clientHeight +
                  2);
            }
            event.preventDefault();
          } else if (
            event.altKey &&
            (event.which === 38 || event.keycode === 38)
          ) {
            // ALT + UP
            this.displayOptionList(
              optionListUL,
              selectTextElement,
              customSelectWrapper
            );
            event.preventDefault();
          } else if (event.which === 27 || event.keyCode === 27) {
            // ESC
            this.hideOptionList(optionListUL, customSelectWrapper);
            event.preventDefault();
          } else if (
            (event.shiftKey && (event.which === 9 || event.keycode === 9)) ||
            event.which === 9 ||
            event.keycode === 9
          ) {
            // TAB or SHIFT + TAB
            this.hideOptionList(optionListUL, customSelectWrapper);
            // event.preventDefault();
          } else if (event.which === 13 || event.keyCode === 13) {
            // ENTER
            if (!this.isOptionVisible) {
              if (this.openonenter === 'true') {
                this.displayOptionList(
                  optionListUL,
                  selectTextElement,
                  customSelectWrapper
                );
                event.preventDefault();
              }
            } else {
              this.displayOptionList(
                optionListUL,
                selectTextElement,
                customSelectWrapper
              );
              event.preventDefault();
            }
          } else {
            // auto select option on pressing of letter
            const input = event.key;
            this.suggestions = this.optionsLIArray.filter(function (item) {
              return (
                item['innerText']
                  .charAt(0)
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) > -1
              );
            });
            if (this.suggestions.length > 0) {
              // execute only if match found
              if (this.optionIndex + 1 === this.suggestions.length) {
                this.optionIndex = 0;
              } else {
                this.optionIndex++;
              }
              this.currSelectedIndex =
                this.suggestions[this.optionIndex].attributes['data'].value;
              this.setActiveValue(
                this.currSelectedIndex,
                selectTextElement,
                optionListUL
              );
              if (this.isOptionVisible) {
                this.setActiveFocus(
                  optionListUL.children[this.currSelectedIndex],
                  optionListUL
                );
              }
            }
          }
          // this.setSRContent(this.customSROnlyValue, this.customSROnlyState, selectTextElement, event);
        });
      }
    }
  }

  /* Set the active value of the select box. Takes below as parameter
    currValue = current selected Index,
    spanElem = custom span element which displays the value
    opList = UL element holding the list of options
    evt (optional) = event that is fired
  */
  public setActiveValue(currValue, spanElem, opList, evt?) {
    if (
      evt &&
      evt.target &&
      evt.target.attributes &&
      evt.target.attributes.data &&
      evt.target.attributes.data.value
    ) {
      this.el.nativeElement.selectedIndex = evt.target.attributes.data.value;
      spanElem.innerText = evt.target.innerText;
    } else {
      this.el.nativeElement.selectedIndex = currValue;
      spanElem.innerText = opList.children[currValue].innerHTML;
    }
    this.currSelectedIndex = this.el.nativeElement.selectedIndex;
    this.customChangeEvent.emit(
      this.el.nativeElement.options[this.el.nativeElement.selectedIndex].value
    );
  }

  /* returns dropdown suggestions */

  getSuggestions(selectedInputLetter) {
    return this.optionsLIArray.filter(function (item) {
      return (
        item['innerText']
          .toLowerCase()
          .indexOf(selectedInputLetter.toLowerCase()) === 0
      );
    });
  }

  /* Set the focus to the option list. Takes below as parameter
    targetElem = current focused option,
    opList = UL element holding the list of options
  */
  public setActiveFocus(targetElem, opList) {
    this.setActiveHover(targetElem, opList);
    if (targetElem.localName === 'li') {
      targetElem.focus();
    }
  }

  /**
   * Set the required classes to the option list on mouse hover
   */
  public setActiveHover(targetElem, opList) {
    for (let j = 0; j < opList.children.length; j++) {
      this.ren.removeClass(opList.children[j], 'select-ui-optionList-hover');
    }
    if (targetElem.localName === 'li') {
      this.ren.addClass(targetElem, 'select-ui-optionList-hover');
    }
  }

  /* display the options list. Takes below as parameter
    opList = UL element holding the list of options,
    spanElem = custom span element which displays the value,
    selWrap = custom select element wrapper. i.e, <span class="select-ui-wrapper">
  */
  public displayOptionList(opList, spanElem, selWrap, keyc?) {
    let isOptionOpened = false;
    if (spanElem) {
      this.ren.setAttribute(spanElem, 'aria-hidden', 'true');
    }
    if (keyc && (keyc.which === 32 || keyc.keyCode === 32)) {
      this.ren.removeClass(opList, 'hideOption');
      this.ren.setAttribute(opList, 'aria-hidden', 'false');
      this.ren.setAttribute(selWrap, 'aria-expanded', 'true');
      isOptionOpened = true;
    } else if (!this.isOptionVisible) {
      this.ren.removeClass(opList, 'hideOption');
      this.ren.setAttribute(opList, 'aria-hidden', 'false');
      this.ren.setAttribute(selWrap, 'aria-expanded', 'true');
      isOptionOpened = true;
    } else {
      selWrap.focus();
      this.ren.removeClass(opList, 'select-ui-optionUL-overflow');
      this.ren.setAttribute(spanElem, 'aria-hidden', 'false');
      this.ren.addClass(opList, 'hideOption');
      this.ren.setAttribute(opList, 'aria-hidden', 'true');
      this.ren.setAttribute(selWrap, 'aria-expanded', 'false');
      isOptionOpened = false;
    }
    if (isPlatformBrowser(this.platformId)) {
      this.timeouts.push(
        setTimeout(() => {
          for (let j = 0; j < opList.children.length; j++) {
            this.ren.removeClass(
              opList.children[j],
              'select-ui-optionList-hover'
            );
          }
          let tempselectedIndex = this.el.nativeElement.selectedIndex;
          if (this.el.nativeElement.selectedIndex === -1) {
            tempselectedIndex = 0;
          }
          if (
            isOptionOpened &&
            this.el.nativeElement[tempselectedIndex].value !== ''
          ) {
            opList.children[tempselectedIndex].focus();
            this.ren.addClass(
              opList.children[tempselectedIndex],
              'select-ui-optionList-hover'
            );
          }
          if (opList.children[tempselectedIndex].innerText !== '') {
            spanElem.innerText = opList.children[tempselectedIndex].innerText;
          } else {
            spanElem.innerText = opList.children[tempselectedIndex].innerHTML;
          }
          this.currSelectedIndex = this.el.nativeElement.selectedIndex;
          if (!this.isOptionVisible) {
            this.customSROnlyValue.innerText = '';
            this.customSROnlyState.innerText =
              ' combo box ' + spanElem.innerText;
          }
          // this.isOptionVisible = !this.isOptionVisible;
          if (isOptionOpened) {
            this.ren.addClass(opList, 'select-ui-optionUL-overflow');
            this.isOptionVisible = true;
          } else {
            this.isOptionVisible = false;
            this.ren.setAttribute(spanElem, 'aria-hidden', 'false');
          }
        }, 500)
      );
    }
  }

  public stopTimeout() {
    for (let i = 0; i < this.timeouts.length; i++) {
      clearTimeout(this.timeouts[i]);
    }
    this.timeouts = [];
  }

  /* hide the options list. Takes below as parameter
    opList = UL element holding the list of options,
    selWrap = custom select element wrapper. i.e, <span class="select-ui-wrapper">
  */
  public hideOptionList(opList, selWrap) {
    this.ren.addClass(opList, 'hideOption');
    this.ren.setAttribute(opList, 'aria-hidden', 'true');
    this.ren.setAttribute(selWrap, 'aria-expanded', 'false');
    this.customSROnlyState.innerText = '';
    this.customSROnlyValue.innerText = '';
    this.isOptionVisible = false;
    if (selWrap && selWrap instanceof Element) {
      this.ren.setAttribute(
        selWrap.querySelector('.select-ui-text'),
        'aria-hidden',
        'false'
      );
    }
    this.customSelectwraperholder.focus();
  }

  /* set the content for the AT to read. Takes below as parameter
    srval = value AT need to read,
    srstate = state AT need to read
    spanElem = custom span element which displays the value,
    evt = event that is fired
  */
  public setSRContent(srval, srstate, spanElem, evt) {
    // execute else block when ESC, TAB or SHIFT + TAB pressed
    const currSRValue =
      spanElem.innerText +
      ' ' +
      (this.currSelectedIndex + 1) +
      ' of ' +
      this.el.nativeElement.options.length;
    if (
      evt.which !== 27 &&
      evt.keyCode !== 27 &&
      !evt.shiftKey &&
      evt.which !== 9 &&
      evt.keyCode !== 9
    ) {
      if (!this.isOptionVisible) {
        srval.innerText = '';
        srstate.innerText = ' combo box ' + spanElem.innerText;
      } else {
        if (srval.innerText !== currSRValue) {
          srval.innerText = currSRValue;
          if (srstate.innerText !== 'list') {
            srstate.innerText = 'list';
          }
        }
      }
    }
  }
}
